<script>
import Swiper from 'swiper'

export default {
  props: {
    troupe: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      swiper: null,
      lengthSlider: false
    }
  },
  mounted() {
    this.swiper = new Swiper(this.$refs.swiper, {
      slidesPerView: 6,
      speed: 400,
      freeMode: true,
      initialSlide: 0,
      autoplay: true,
      delay: 1000,
      loop: false,
      breakpoints: {
        320: {
          slidesPerView: 1.9
        },
        640: {
          slidesPerView: 3.9
        },
        1024: {
          slidesPerView: 5
        },
        1280: {
          slidesPerView: 6
        }
      }
    })
  },
  computed: {
    persons() {
      let arr = []
      this.troupe.forEach((staging) => {
        if (staging.name) {
          const arrayPersons = staging.name.split(',')
          arrayPersons.forEach((person) => {
            arr.push({
              title: staging.title,
              name: person,
              img: null,
              to: null
            })
          })
        } else {
          staging.value.forEach((person) => {
            if (person?.name)
              arr.push({
                title: staging.title,
                name: person?.name,
                img: person.img.fileKey ?? null,
                to: `/theater/troupe/${person._id}`
              })
          })
        }
      })
      if (arr.length > 6) {
        this.lengthSlider = true
      }
      return arr
    },
    isSlider() {
      return true
    }
  }
}
</script>

<template>
  <section class="flex flex-col space-y-7 pt-3" v-if="persons.length">
    <div class="w-full text-left">
      <h4 class="text-xl font-sans text-dark-gray">
        Действующие лица и исполнители
      </h4>
    </div>
    <div class="block relative h-70">
      <div class="absolute w-screen lg:w-full -left-4" v-if="isSlider">
        <div class="relative swiper-container" ref="swiper">
          <div class="swiper-wrapper">
            <RPerformTroupeCard
              v-for="staff in persons"
              :key="staff.img"
              class="swiper-slide lastchild"
              :name="staff.name"
              :title="staff.title"
              :img-uuid="staff.img"
              :to="staff.to"
            />
          </div>
        </div>
        <div
          class="slide-next absolute -left-12 top-20 z-10 cursor-pointer hidden xl:block"
          v-if="lengthSlider"
          @click="swiper.slidePrev()"
        >
          <img
            loading="lazy"
            src="/arrow-l.svg"
            alt=""
          />
        </div>
        <div
          class="slide-next absolute -right-12 top-20 transform rotate-180 z-10 cursor-pointer hidden xl:block"
          v-if="lengthSlider"
          @click="swiper.slideNext()"
        >
          <img
            loading="lazy"
            src="/arrow-l.svg"
            alt=""
          />
        </div>
      </div>
      <div
        class="w-full relative grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-7"
        v-else
      >
        <RPerformTroupeCard
          v-for="staff in persons"
          :key="staff.img"
          class="swiper-slide"
          :name="staff.name"
          :title="staff.title"
          :img-uuid="staff.img"
          :to="staff.to"
        />
      </div>
    </div>
  </section>
</template>
<style scoped>
.lastchild:last-child {
  padding-right: 16px !important;
}
</style>
